// Library methods

// Utils
import { POST } from '../../../utils/fetchWrappers';

// API URLs
import { API_MERCHANT_UPDATE_STATUS } from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as merchantOnboardStatusActions from './MerchantOnboardStatus.actions';

// Constants
import { FETCH_UPDATING_MERCHANT_REQUEST } from './MerchantOnboardStatus.constants';

import { takeLatest, put, call } from 'redux-saga/effects';
import moment from 'moment';

export function* fetchUpdatingMerchantsDetails(actions) {
    yield put(merchantOnboardStatusActions.showLoader());
    try {
        const { payload } = actions;
       

        const request = {
            paging: {
                pageNumber: payload.pageIndex || 1,
                pageSize: payload.pageSize || 10,
            },
        };

        if (payload.sectionType) {
            request.category = payload.sectionType;
        }

        if (payload.entityCode) {
            request.entityCode = payload.entityCode;
        }

        if (payload.state) {
            request.state = payload.state;
        }

        if (payload.updatedBy && payload.updatedBy.length > 0) {
            request.userId = payload.userEmailId;
        }

        if (payload.createdOn) {
            request.startDateTime = moment(payload.createdOn.startDate)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            request.endDateTime = moment(payload.createdOn.endDate)
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
        }

        const { data } = yield call(POST, API_MERCHANT_UPDATE_STATUS, request);

        if (
            data &&
            (data.statusCode === apiStatusCodes.SUCCESS ||
                data.statusCode === apiStatusCodes.SUCCESS2)
        ) {
            yield put(
                merchantOnboardStatusActions.fetchUpdatingMerchantSuccess(data)
            );
        } else if (data && data.errorMessage) {
            yield put(
                merchantOnboardStatusActions.fetchUpdatingMerchantError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;

        yield put(
            merchantOnboardStatusActions.fetchUpdatingMerchantError({
                error: data,
            })
        );
    }
    yield put(merchantOnboardStatusActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* merchantOnboardStatusSaga() {
    yield takeLatest(
        FETCH_UPDATING_MERCHANT_REQUEST,
        fetchUpdatingMerchantsDetails
    );
}
